<div class="about-page-wrapper">
  <!-- Hero Section -->
  <div class="about-hero text-center py-5 px-3 mb-5">
    <div class="container py-4">
      <span class="pill-tag gold mb-3">About ADVIBE</span>
      <h1 class="main-hero-title font-weight-bold mb-3">Where Visibility Meets Opportunity</h1>
      <p class="hero-subtitle mx-auto">
        Empowering brands to stand out, connect deeply with their audience, and ignite long-term business success.
      </p>
    </div>
  </div>

  <div class="container pb-5 px-4">
    <!-- Welcome Section (Two Column Layout) -->
    <div class="row align-items-center mb-5 py-4">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <h2 class="section-title font-weight-bold mb-3">Welcome to ADVIBE</h2>
        <p class="text-muted leading-relaxed animate-fadein" style="font-size: 1.05rem; line-height: 1.7;">
          You are at the premier destination for businesses seeking
          unparalleled visibility and engagement across a vast array of
          industries. Our platform is designed to revolutionize the way
          businesses connect with their audience, providing a dynamic and
          intuitive space where brands can thrive and followers can discover
          their next favorite venture.
        </p>
      </div>
      <div class="col-lg-6">
        <!-- Visual Stats Card -->
        <div class="stats-showcase-card text-center p-5">
          <div class="stat-number mb-2" [countUp]="categoryCount">{{categoryCount}}</div>
          <div class="stat-label text-muted font-weight-bold tracking-wider text-uppercase">Active Categories</div>
          <p class="text-muted mt-3 small">
            Providing endless opportunities for local businesses and searchers.
          </p>
        </div>
      </div>
    </div>

    <!-- Core Values/Pillars Section -->
    <div class="row mb-5 justify-content-center">
      <!-- Pillar 1: We Understand -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="modern-card p-4 h-100 d-flex flex-column text-center align-items-center">
          <div class="card-icon-wrapper mb-3 bg-primary-light text-primary">
            <fa-icon [icon]="faLightbulb" size="lg"></fa-icon>
          </div>
          <h3 class="font-weight-bold mb-3">We Understand</h3>
          <p class="text-muted flex-grow-1" style="font-size: 0.95rem; line-height: 1.6;">
            At ADVIBE, we understand the importance of being seen in today's digital landscape. Our platform offers the perfect stage to showcase your offerings and captivate your target audience.
          </p>
        </div>
      </div>

      <!-- Pillar 2: We're Different -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="modern-card p-4 h-100 d-flex flex-column text-center align-items-center">
          <div class="card-icon-wrapper mb-3 bg-blue-light text-blue">
            <fa-icon [icon]="faCompass" size="lg"></fa-icon>
          </div>
          <h3 class="font-weight-bold mb-3">We're Different</h3>
          <p class="text-muted flex-grow-1" style="font-size: 0.95rem; line-height: 1.6;">
            What sets ADVIBE apart is our commitment to fostering meaningful connections. Our user-friendly interface makes discovery simple, while robust tools empower growth.
          </p>
        </div>
      </div>

      <!-- Pillar 3: Collaboration & Support -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="modern-card p-4 h-100 d-flex flex-column text-center align-items-center">
          <div class="card-icon-wrapper mb-3 bg-green-light text-green">
            <fa-icon [icon]="faHandshake" size="lg"></fa-icon>
          </div>
          <h3 class="font-weight-bold mb-3">We Believe</h3>
          <p class="text-muted flex-grow-1" style="font-size: 0.95rem; line-height: 1.6;">
            We believe in collaboration and mutual support. ADVIBE is a community where businesses can join forces, share insights, and grow together in a supportive home.
          </p>
        </div>
      </div>
    </div>

    <!-- Call to Action Banner -->
    <div class="row justify-content-center mt-5">
      <div class="col-lg-10">
        <div class="about-cta-card text-center p-5 text-white">
          <div class="cta-overlay"></div>
          <div class="cta-content relative z-10">
            <h2 class="font-weight-bold text-white mb-3">Join Us on This Exciting Journey</h2>
            <p class="mx-auto mb-4 text-white-80" style="max-width: 600px; font-size: 1.05rem; line-height: 1.6;">
              Whether you're a business looking to expand your horizons or a follower eager to discover the next big thing, we invite you to join us. Welcome to ADVIBE—where visibility meets opportunity.
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-3">
              <button mat-flat-button color="primary" class="rounded-pill px-4 py-2 font-weight-bold text-white bg-primary" style="box-shadow: 0 4px 12px rgba(177, 135, 49, 0.3);" (click)="goTo('register')">
                Vibe For Free
              </button>
              <button mat-flat-button color="accent" class="rounded-pill px-4 py-2 font-weight-bold text-white bg-secondary" style="box-shadow: 0 4px 12px rgba(28, 141, 156, 0.3);" (click)="goTo('register')">
                List My Business
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
